import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import { FieldType } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { DocumentService } from 'projects/shared/src/lib/services/document.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';



//-------------------------------------------------------------------------------------------

// Notice this is a regular Angular component which extends of the FieldType class. 
// This gives you access to the following variables:

// form: FormGroup;
// field: FormlyFieldConfig;
// model: any;
// options: FormlyFormOptions;
// readonly key: string;
// readonly formControl: AbstractControl;
// readonly to: FormlyTemplateOptions;
// readonly showError: boolean;
// readonly id: string;
// readonly formState: any;

// With those variables, you have total control of the form. 
// These variables allow you to generate buttons with form actions (submit, reset, etc) or generate custom error messages. 
// The most used variable here is “to”. It gives access to all the properties defined on templateOptions.
//--------------------------------------------------------------------------------------------

@Component({
  selector: 'al-select-type',
  templateUrl: './al-select-type.component.html',
  styleUrls: ['./al-select-type.component.scss']
})
export class AlSelectTypeComponent extends FieldType implements OnInit {

  @Output() docStatus = new EventEmitter<any>();

  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  documentId!: string;
  controlfield!: string;

  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService,
    private documentService: DocumentService) {
    super();
  }

  override ngOnInit(): void {
    
    this.dbName = localStorage.getItem('dbname') as string;

    this.dataSharingService.tabIdChanges$.subscribe({
      next: (pageId:any) => {
        this.pageId = pageId as string;
      },
      // error: error => this.errorMessage = ErrorFormat.formatError(error)
    });

    this.documentId = localStorage.getItem('doc-id') as string;
    this.pageId = localStorage.getItem('page-id') as string;

    this.attributeValueService.loadCurrentAttributeValue('', this.documentId, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto:any) => {
        JSON.parse(currentAttributeValueDto.controlData);
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  change(key: any, id: any, formControlValue: any) {
    let formData:any = {};
    formData[key] = formControlValue;

    this.attributeValueService.createAttributValueInfo(this.documentId, this.pageId, formData, key, id, this.dbName).subscribe({
      next: (data:any) => {

        if (key === 'project_type') {
          this.docStatus.emit(formControlValue)
          this.dataSharingService.changeDocumentStatusState(formControlValue);
        }
      },
      // error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }
}









